// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import chapterRevisionEntity from './entities/chapter-revision.json';
import chapterRevisionMenu from '../pages/chapter-revision/menu.json';
import chapterRevisionFullForm from '../pages/chapter-revision/forms/full.json';
import chapterRevisionContextForm from '../pages/chapter-revision/forms/context.json';
import chapterRevisionMiniForm from '../pages/chapter-revision/forms/mini.json';
import chapterRevisionLookupForm from '../pages/chapter-revision/forms/lookup.json';
import chapterRevisionTableView from '../pages/chapter-revision/views/table.json';
import chapterRevisionCardsView from '../pages/chapter-revision/views/cards.json';
import chapterRevisionDashboardView from '../pages/chapter-revision/views/dashboard.json';

/** Тип запису «Редакція програми» зі сторінками пакета: меню, форми та подання з pages/chapter-revision/. */
export const chapterRevisionDefinition: IRecordTypeDefinition = {
  ...chapterRevisionEntity,
  views: assembleViewSet({
      table: chapterRevisionTableView,
      cards: chapterRevisionCardsView,
      dashboard: chapterRevisionDashboardView,
  }),
  form: chapterRevisionFullForm,
  forms: { full: chapterRevisionFullForm, context: chapterRevisionContextForm, mini: chapterRevisionMiniForm, lookup: chapterRevisionLookupForm },
  menu: chapterRevisionMenu,
} as IRecordTypeDefinition;
